import { mapState, mapActions, mapMutations } from "vuex";
import Util from '../../util/funcoes';

export default {
  data() {
    return {
      isLoading: false,
    }
  },

  created() {
    this.listar();
  },

  computed: {
    ...mapState('contratosReajusteStore', {
      contratosReajuste(state) { return state.listaContratosReajuste }
    }),

    tooltipQuantidadeContratosIsVisible() {
      return this.contratosReajuste.length > 0
    },

    quantidadeContratos() {
      const quantidade = this.contratosReajuste.length

      switch (quantidade) {
        case 1:
          return 'Exibindo 1 contrato.'
        default:
          return `Exibindo ${quantidade} contratos.`
      }
    }
  },

  methods: {
    ...mapActions('contratosReajusteStore', [
      'recuperarContratosReajuste'
    ]),
    ...mapMutations('contratosReajusteStore', [
      'limparListaContratosReajuste'
    ]),

    listar() {
      const payload = {
        dataInicio: Util.avançarPeriodoDaData(Util.stringParaData(Util.primeiroDiaMes()), 1),
        dataFim: Util.avançarPeriodoDaData(Util.stringParaData(Util.ultimoDiaMes()), 1) 
      }

      this.showLoading();
      this.limparListaContratosReajuste();
      this.recuperarContratosReajuste(payload)
      .then()
      .finally(() => {
        this.hideLoading();
      });
    },
    
    showLoading() {
      this.isLoading = true;
    },
    hideLoading() {
      this.isLoading = false;
    },

    formatarLabelValor(item) {
      return Util.formatarValor(item.valor);
    },

  }
}